const translations = {
  "quest": {
    "name": "Dplay",
    "loading": "Loading",
    "readytocast": "Ready to Cast",
    "error": "An error has occured. Please try again.",
    "errorGeoblock": "This video is not available in your region",
    "live": "LIVE"
  },
  "dmax": {
    "name": "DMAX",
    "loading": "Lädt…",
    "readytocast": "Bereit zur Wiedergabe",
    "error": "Fehler! Neuer Versuch?",
    "errorGeoblock": "Dieses Video ist in deinem Land nicht verfügbar",
    "live": "LIVE"
  },
  "tlc": {
    "name": "TLC",
    "loading": "Lädt…",
    "readytocast": "Bereit zur Wiedergabe",
    "error": "Fehler! Neuer Versuch?",
    "errorGeoblock": "Dieses Video ist in deinem Land nicht verfügbar",
    "live": "LIVE"
  }
}

module.exports = translations;


// WEBPACK FOOTER //
// ./src/translations/index.js